module.exports = __webpack_public_path__ + "img/basketball-hoop.ab855c0b.svg";